<template>
  <div id="app" :class="{'nav-open': $sidebar.showSidebar}">
    <!--
    <notifications></notifications>
    -->
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentRouterName: ''
    }
  }
};
</script>

<style lang="scss">
  #app {
    zoom: 100%;
    font-family:Consolas,Monaco,Lucida Console,Liberation Mono,DejaVu Sans Mono,Bitstream Vera Sans Mono,Courier New, monospace;
  }
  .form-container {
    margin: 40px 0;
    min-height: 10px;
  }
  .vue-notifyjs.notifications {
    .alert {
      z-index: 10000;
    }
    .list-move {
      transition: transform 0.3s, opacity 0.4s;
    }
    .list-item {
      display: inline-block;
      margin-right: 10px;
    }
    .list-enter-active {
      transition: transform 0.2s ease-in, opacity 0.4s ease-in;
    }
    .list-leave-active {
      transition: transform 1s ease-out, opacity 0.4s ease-out;
    }

    .list-enter {
      opacity: 0;
      transform: scale(1.1);
    }
    .list-leave-to {
      opacity: 0;
      transform: scale(1.2, 0.7);
    }
  }
  .create-new {
    position: fixed;
    bottom: 30px;
    right: 30px;
    width: 64px;
    height: 64px;
    background: #27A5C1;
    z-index: 3;
    border-radius: 40px;
    text-align: center;
    cursor: pointer;
    span {
      font-size: 20pt;
      line-height: 64px;
      color: white;
      margin: auto;
    }
  }
  .search-table-item {
    display: flex;
    list-style: none;
    padding: 20px;
    background: white;
    border: #F0F0F0 1px solid;
    span {
      font-size: 15pt;
      line-height: 50px;
    }
    input {
      font-size: 15pt;
      line-height: 50px;
      height: 50px;
      background: white;
    }
  }
  .image-content {
    background-color: gray;
    div {
      width: 100%;
      height: 100%;
      text-align: center;
      i {
        line-height: 80px;
        color: white;
        font-size: 28px;
      }
    }
  }
  .list-image {
    width: 80px;
    height: 80px;
    div {
      i {
        line-height: 80px;
      }
    }
  }
  .exhibition-image {
    width: 300px;
    height: 430px;
    div {
      i {
        line-height: 430px;
      }
    }
  }
  .collection-image {
    width: 300px;
    height: 400px;
    div {
      i {
        line-height: 400px;
      }
    }
  }
  .horoscope-image {
    width: 300px;
    height: 454px;
    margin: auto;
    div {
      i {
        line-height: 454px;
      }
    }
  }
  .detail-image {
    width: 300px;
    height: 300px;
    div {
      i {
        line-height: 300px;
      }
    }
  }
  .router-title {
    line-height: 50px;
    font-size: 25px;
    font-weight: bolder;
    margin: 20px 0;
  }
  .tfam-custom-tabs {
    .el-tabs__active-bar {
      background-color: #27A5C1;
    }
    .el-tabs__nav {
      div {
        font-weight: normal;
      }
      .is-active {
        color: #27A5C1;
      }
    }
  }
  .tfam-button {
    border-color: #444 !important;
    background: white !important;
    color: #444 !important;
  }
  .tfam-button:hover {
    border-color: #444 !important;
    background: #444 !important;
    color: white !important;
  }
  .range-content {
    display: flex;
    .divider {
      margin: 0 10px;
    }
    .el-input {
      width: 150px;
    }
  }
  .tfam-upload {
    .el-upload-list__item {
      border-width: 0 !important;
    }
    .picture-card-style-control {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.6);
      opacity: 0;
      text-align: center;
      .file-name {
        word-wrap: break-word;
        white-space: normal;
        line-height: 25px;
        font-size: 18px;
        color: white;
        position: absolute;
        left: 5px;
        top: 30px;
        bottom: 5px;
        right: 5px;
        height: fit-content;
        margin: auto;
      }
      .remove-button {
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        font-size: 25px;
        line-height: 30px;
        color: white;
        cursor: pointer;
      }
    }
    .picture-card-style-control:hover {
      opacity: 1;
    }
  }
  .beacon-events {
    text-align: right;
    width: fit-content;
    height: 25px;
    float: right;
    margin-right: 20px;
    padding: 0 10px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 13px;
    cursor: pointer;
    max-width: 85%;
    span {
      cursor: pointer;
      color: darkgray;
      display: block;
      text-overflow: ellipsis;
      word-wrap: break-word;
      overflow: hidden;
      white-space: nowrap;
      height: 25px;
      line-height: 25px;
    }
  }
  .beacon-events:hover {
    border-color: #444;
    span {
      color: #444;
    }
  }
  .beacon-events.active {
    border-color: #444;
    span {
      color: #444;
    }
  }
  .beacon-events.active:hover {
    background-color: #444;
    border-color: #444;
    span {
      color: white;
    }
  }
  .el-table::before {
    background: #f4f3ef !important;
  }
  .el-table__body-wrapper {
    background: #f4f3ef !important;
  }
  .tfam-dialog {
    .el-dialog {
      width: 400px;
      max-width: 90%;
    }
  }
</style>
